export default __webpack_public_path__ + "locales/az/SocialAuthWelcomeDialog.json?hash=d671efa6bed617c08ad8b5913c45d394";